module.exports = __webpack_public_path__ + "static/media/mtg-cardback.7cb28748.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/mtg-cardback.jpg
 ** module id = 437
 ** module chunks = 0
 **/